<template>
  <div class="helpCenterDetail">
      <cube-scroll 
        ref="scroll"
        :options="options"
        class="page_scroll bodyBg">
        <div class="help_info-box">
            <h3>{{help_info.title}}</h3>
            <h5>{{help_info.title1}}</h5>
            <div>
                <img :src="help_info.img" alt="" v-show="help_info.img">
                <p class="text" v-html="help_info.text"></p>
                <video id="video1" controls v-if="help_info.video">
                    <source :src="help_info.video" type="video/mp4">
                    <embed  :src="help_info.video" width="100%" autostart="false" />
                </video>
            </div>
        </div>
      </cube-scroll>
  </div>
</template>
<script>
export default {
  name: 'helpCenterDetail',
  data () {
    return {
      options: {},
      help_id: this.$route.params.helpId,
      help_info: {}
    }
  },
  mounted () {
    this.$loading.show()
    this.$share.WxInit('恩氏基因', '恩氏基因', '', '', this.help_id)
  },
  created () {
    this.getInit()
    this.$share.WxInit('恩氏基因', '恩氏基因', '', '', this.help_id)
  },
  methods: {
    getInit () {
      this.$http.api.helpDetail({
        help_id: this.help_id
      }).then(result => {
        this.$loading.hide()
        this.help_info = {...result}
        // this.help_info.video = this.help_info.video.split('?')[0]
        // http://zuhaojia.oss-cn-hangzhou.aliyuncs.com/bc13e2b46744444c972be30693bda008.mp4?Expires=1564471731&OSSAccessKeyId=LTAIHcpU5rhnzEl0&Signature=gXZ8WgKzFT4BvlFLyJ1Kr0Rr1Xs%3D
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page_scroll{
  bottom: 0;
}
.helpCenterDetail{
  width: 100%;
  height: 100%;
  .help_info-box {
    width: 100%;
    padding: 20px 15px 20px;
    background: #fff;
    h3{
      font-size: 20px;
      width: 100%;
      margin-bottom: 5px;
      text-align: center;
    }
    h5{
      font-size: 12px;
      text-align: center;
      color: #333;
      margin-bottom: 10px;
    }
  }
  .text{
    padding: 15px 0px;
  }
  #video1 {
    width: 100%;
    height: 300px;
  }
}
</style>
